import { LoginIcon } from '@heroicons/react/outline'
import { DocumentAddIcon } from '@heroicons/react/solid'
import React from 'react'
import { Button, Container, Element, Form, Icon, Section } from 'react-bulma-components'
import { Link } from 'react-router-dom'
import { Column } from 'react-table'
import Layout from '../../components/layout/layout'
import ComponentHeader from '../../components/sections/component-header'
import PageHeading from '../../components/sections/page-heading'
import Table from '../../components/table'
import { useOrganizationsQuery } from '../../queries/organizations'
import useStore from '../../store'
import { Employer } from '../../api/organizations'

const EmployersList: React.FunctionComponent = () => {
  const employersQuery = useOrganizationsQuery<Employer>({ sort: 'name', type: 'employer' })
  const tableColumns = useListTableColumns((employersQuery.data as Employer[]) || [])

  return (
    <Layout>
      <PageHeading title="Liste des Employeurs" />
      <Section>
        <Container>
          <ComponentHeader>
            <ComponentHeader.Left></ComponentHeader.Left>
            <ComponentHeader.Right>
              <Form.Field>
                <Form.Label>&nbsp;</Form.Label>
                <Form.Control>
                  <Button renderAs={Link} to="/employers/new" outlined color="primary">
                    <Icon>
                      <DocumentAddIcon />
                    </Icon>
                    <span>Nouvel Employeur</span>
                  </Button>
                  <Element></Element>
                </Form.Control>
              </Form.Field>
            </ComponentHeader.Right>
          </ComponentHeader>
          <Table
            columns={tableColumns}
            data={employersQuery.data || []}
            noDataMessage="Aucune société à afficher"
          />
        </Container>
      </Section>
    </Layout>
  )
}

export default EmployersList

const useListTableColumns = (organizations: Employer[]): Column[] => {
  const loginAs = useStore(state => state.session.loginAs)
  return React.useMemo(
    () =>
      [
        {
          Header: 'Nom',
          accessor: 'name',
          Cell: (data: any) => {
            const organization: Employer = data.cell.row.original
            return <Link to={`/employers/${organization._id}/info`}>{organization.name}</Link>
          },
        },
        {
          Header: '',
          accessor: 'loginAs',
          Cell: (data: any) => {
            const organization: Employer = data.cell.row.original
            return (
              <Button size="small" onClick={() => loginAs('employerMember', organization, 'admin')}>
                <Icon>
                  <LoginIcon />
                </Icon>
              </Button>
            )
          },
        },
      ] as Column[],
    [organizations],
  )
}
